import React from "react";
import PropTypes from "prop-types";

import { BannerContainer, BannerInnerContainer, BannerContent } from "./styles";

import CloseButton from "./CloseButton";
import { sitewideBannerTypes } from "core/props";

const PrivacyPolicyBanner = ({ type = "privacy", bannerDismiss }) => {
    return (
        <BannerContainer
            type={type}
            data-callback="accounts/hide-privacy-banner"
            data-banner-show-anonymous="true"
        >
            <BannerContent>
                <BannerInnerContainer>
                    We’ve updated our{" "}
                    <a href="/legal/terms-of-use/">Terms of Use</a> &amp;{" "}
                    <a href="/legal/privacy-policy/">Privacy Policy</a> to
                    launch Photos
                </BannerInnerContainer>
            </BannerContent>

            <CloseButton bannerDismiss={bannerDismiss} />
        </BannerContainer>
    );
};

PrivacyPolicyBanner.propTypes = {
    type: PropTypes.oneOf(sitewideBannerTypes),
    bannerDismiss: PropTypes.func
};

export default PrivacyPolicyBanner;
